import { styled } from "@mui/material/styles";
import Link from "next/link";

export const TermsContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: theme.space._500,
  maxWidth: theme.space._1250,
  alignSelf: "strech",

  "@media (max-width: 600px)": {
    maxWidth: "unset",
  },
}));

export const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.colors["blue.400"],
  textDecoration: "none"
}));